<div *ngIf="(loader.isLoadingOverlay$ | async)" class="spinner-overlay">
    <div class="loader"></div>
  </div>